document.addEventListener('DOMContentLoaded', () => {
  const triggerButtons = [];
  const tradeProgramButtons = document.querySelectorAll('[id*="__rich_text"] .button');
  const tradeProgramButton = document.querySelector('#tradeProgramButton');
  const tradeProgramModal = document.getElementById('tradeProgramModal');
  const tradeProgramCloseButton = document.getElementById('tradeProgramModalClose');
  const modalOverlay = document.querySelector('.modal-overlay');

  tradeProgramButtons.forEach(button => {
    triggerButtons.push(button);
  });
  triggerButtons.push(tradeProgramButton);

  const mainContent = document.querySelector('#MainContent');

  // Flag to prevent duplicate submissions
  let hasSubmitted = false;

  // Add a class to the modal after the page loads to prevent the transition from running on page load
  setTimeout(() => {
    tradeProgramModal.classList.add('transition-ready');
  }, 400);

  mainContent.addEventListener('click', (event) => {
    const isTriggerButton = triggerButtons.includes(event.target);
    if (isTriggerButton) {
      hideFormTitle();
      openTradeProgramModal();

      const shadowHost = document.querySelector('#app-embed');
      if (shadowHost) {
        const shadowRoot = shadowHost.shadowRoot;

        // Function to handle submission
        const handleSubmission = () => {
          if (!hasSubmitted) {
            hasSubmitted = true;
            bindGTCustomEvent('conversion');
            createCustomEvent('trade_program_form_submitted');
            // Reset the flag after a delay
            setTimeout(() => {
              hasSubmitted = false;
            }, 2000); // Reset after 2 seconds
          }
        };

        // Add click event listener to the shadow root
        shadowRoot.addEventListener('click', (event) => {
          const submitButton = event.target.closest('[data-testid="btn-form-submit"]');
          if (submitButton) {
            event.stopPropagation();
            handleSubmission();
          }
        }, true);

        // Also listen for form submission
        const formElement = shadowRoot.querySelector('form');
        if (formElement) {
          formElement.addEventListener('submit', (event) => {
            handleSubmission();
          });
        }
      }
    }
  });

  tradeProgramCloseButton.addEventListener('click', () => {
    closeTradeProgramModal();
  })

  modalOverlay.addEventListener('click', (event) => {
    const isOutside = !event.target.closest('.trade-program-modal-content');
    if (isOutside) {
      closeTradeProgramModal();
    }
  })

  document.addEventListener('keydown', (event) => {
    if (tradeProgramModal.classList.contains('open')) {
      if (event.key === "Escape" || event.key === 'Enter') {
        closeTradeProgramModal();
      }
    }
  });

  function openTradeProgramModal() {
    tradeProgramModal.classList.add('open');
    modalOverlay.classList.add('open');

    disableScrolling();
  }

  function closeTradeProgramModal() {
    tradeProgramModal.classList.remove('open');
    modalOverlay.classList.remove('open');

    enableScrolling();
  }

  function disableScrolling() {
    document.body.style.overflow = 'hidden';
  }

  function enableScrolling() {
    document.body.style.overflow = 'auto';
  }

  function hideFormTitle() {
    const tradeProgramFormTitle = document.querySelector('#app-embed').shadowRoot.querySelector('._textHeading_2aowh_35');

    if (tradeProgramFormTitle) {
      tradeProgramFormTitle.setAttribute(
        "style",
        "display: none;"
      );
    }
  }

  function bindGTCustomEvent(event) {
    try {
      gtpx(event, { value: 'trade_program_form' });
    } catch (error) {
      console.error('Error creating custom event:', error);
    }
  }

  function createCustomEvent(event) {
    try {
      // Ensure dataLayer exists
      window.dataLayer = window.dataLayer || [];
      // Create the event object with GA4-friendly structure
      const eventData = {
        'event': event,
        'page_location': window.location.href,
        'page_title': document.title,
        'form_name': 'trade_program_form',
        'timestamp': new Date().toISOString()
      };

      // Push to dataLayer
      window.dataLayer.push(eventData);
    } catch (error) {
      console.error('Error creating custom event:', error);
    }
  }
});